<template>
  <div class="getCoupon">
    <!-- <div class="titleTop" v-if="!inWxAPP">{{queryCouponData.activityName}}</div> -->
    <img src="https://gfhapi.zkungfu.com/image2/upload/20230831/4137ee8adbcb47b8af7b1bb20f953184.jpg" v-if="type == 'volunteer'" class="volunteerBanner" alt="">
    <div
      class="content"
      :style="{backgroundImage:'url('+(type == 'volunteer' ? '' : queryCouponData.landingPageUrl?queryCouponData.landingPageUrl:'')+')'}"
    >
      <!-- didWriting = true 意思是 已领取 -->
      <div class="bottom">
        
        <!-- 输入框 -->
        <div class="inputPhoneArea" v-show="!didWriting && type != 'volunteer'">
          <input
            type="tel"
            placeholder="请输入您的手机号"
            class="inputPhone"
            v-model="inputPhone"
            @blur="didBlur"
          />
        </div>
        <!-- 去领取按钮 -->
        <div class="volunteerBotton test1" v-show="type == 'volunteer'">
          <img
            src="https://gfhapi.zkungfu.com/image2/upload/20220104/353f469cb1c6420c81fa1235771a9bde.png"
            class=""
            @click="getCouponClick"
          />
          <div>*每人每日限领1次</div>
        </div>
        <div class="getCouponBottonArea test1" v-show="!didWriting && type != 'volunteer'">
          <img
            :src="queryCouponData.writingBeforeReceive"
            class="getCouponBotton"
            @click="getCouponClick"
          />
        </div>
        <!-- 去使用按钮 -->
        <div class="getCouponBottonArea test2" v-show="didWriting && type != 'volunteer'">
          <img
            :src="queryCouponData.writingAfterReceive"
            class="getCouponBotton"
            @click="useCouponClick"
          />
        </div>

        <!-- 使用规则 -->
        <p class="useRule" @click="showRulePopup" v-show="type != 'volunteer'">使用规则</p>

      </div>
    </div>
    <!-- 规则弹窗 -->
    <div v-show="rulePopShow" class="rulePop" @click.self="hiddenRulePopup">
      <div class="popContent">
        <div class="title">使用规则</div>
        <div class="detail" v-html="queryCouponData.ruleUrl"></div>
        <div class="btnArea" @click="hiddenRulePopup">
          <button class="btn">我知道了</button>
        </div>
      </div>
    </div>
    <!-- 温馨提示页 -->
    <div v-show="tipPopShow" class="tipPop" @click.self="hiddenTipPopup">
      <div class="popContent">
        <div class="title">温馨提示</div>
        <div class="lineYellow"></div>
        <div class="tip" v-html="queryCouponData.tipUrl"></div>
        <div class="btnArea">
          <button class="btn" @click.self="hiddenTipPopup">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Popup, cell, Overlay } from "vant";
import report from "../utils/report.js";



Vue.use(Popup);
export default {
  name: "getCoupon",
  data() {
    return {
      inputPhone: "",
      queryCouponData: {},
      rulePopShow: false, //规则弹窗展示
      tipPopShow: false, //提示弹窗展示

      didWriting: false, //已经领取
      discountId: "",
      type: '', // 是否志愿活动

      inWxAPP: false,
      lock: false
    };
  },
  created() {
    console.log();
    if (window.__wxjs_environment === "miniprogram") {
      wx.miniProgram.getEnv(res => {
        if (res.miniprogram) {
          //是小程序内
          this.inWxAPP = true;
        }
      });
    }
    console.log('----------------------');
    console.log(arguments);
    console.log(this.$route);
    console.log('----------------------');

    let query = this.$route.query;

    // let paramsStr = this.$route.params.paramsStr;
    // let params = paramsStr.split("|");
    // this.paramsStr = paramsStr;
        console.log('query',query);

    if (query.discountId) this.discountId = query.discountId;
    if (query.tel) this.inputPhone = query.tel;
    if (query.type) {
        this.type = query.type
        return
      }
    console.log('this.discountId',this.discountId);
    this.GFH_POST("queryCouponH5", {
      discountId: this.discountId
    })
      .then(res => {
        this.queryCouponData = res.data;
        if (this.queryCouponData){
          document.title = this.queryCouponData.activityName;
          report.Cooperatem_1001({
            Cooperate_ID: this.discountId,
            Cooperate_Name: this.queryCouponData.activityName
          });
        }
      })
      .catch(err => {
        this.TOAST_Tip(err.message);
        report.Cooperatem_1005({
          Cooperate_Name: this.queryCouponData.activityName,
          Taost_Name: err.message
        });
      });
  },
  methods: {
    didBlur() {
      console.log("失去焦点了");
      window.scroll(0, 0);
    },
    //领券
    getCouponClick() {
      if(this.type === 'volunteer') {
          this.GFH_POST('generateUrlscheme', { path: '/packageSub/pages/activity/H5GetCoupon/login', query: 'type=volunteer' }).then(res => {
            location.href = res.data
          })
          return
      }
      if (this.lock) return;
      this.lock = true;
      if (
        this.inputPhone.length !== 11 ||
        this.inputPhone.substr(0, 1) !== "1"
      ) {
        this.TOAST_Tip("请输入正确的手机号码");
        this.lock = false;
        return;
      }

      this.GFH_POST("getCouponH5", {
        phoneNumber: this.inputPhone,
        discountId: this.discountId
      })
        .then(res => {
          this.lock = false;
          if (res.code == 200) {
            //这里
            this.TOAST_Success(res.data);
            this.didWriting = true;
            report.Cooperatem_1005({
              Cooperate_Name: this.queryCouponData.activityName,
              Taost_Name: res.data
            });
          } else {
            this.TOAST_Tip(res.message);

            report.Cooperatem_1005({
              Cooperate_Name: this.queryCouponData.activityName,
              Taost_Name: res.message
            });
          }
        })
        .catch(err => {
          this.lock = false;
          this.TOAST_Tip(err.message);
          report.Cooperatem_1005({
            Cooperate_Name: this.queryCouponData.activityName,
            Taost_Name: err.message
          });
          if (err.code == 5144) {
            this.didWriting = true;
          }
        });
      report.Cooperatem_1003();
    },


    //使用券
    useCouponClick() {
      if (this.lock) return;
      this.lock = true;
      console.log($flutter);
      console.log(window.spBridge);
      // $flutter.fbOpenMiniProgram({
      //   data: {
      //     username: 'gh_7e50e273522f',
      //     path: '/packageSub/pages/activity/H5GetCoupon/login'
      //   },
      //   success: (res) => {
      //     console.log(res);
      //   },
      //   error: (err) => {
      //     console.log(err);
      //   }
      // })

      if ((window.__wxjs_environment === "miniprogram" || this.type === 'volunteer')) {
        wx.miniProgram.getEnv(res => {
          this.lock = false;
          if (res.miniprogram) {
            console.log("在小程序里");
            this.hiddenTipPopup();
            wx.miniProgram.navigateTo({
              url: "/packageSub/pages/activity/H5GetCoupon/login",
              success: function(res) {
                // this.TOAST_Success("1");
              },
              fail: function(res) {
                // this.TOAST_Success("2");
              },
              complete: function(res) {}
            });
          } else {
            console.log("不在小程序里");
            this.showTipPopup();
          }
        });
      } else {
        this.lock = false;
        console.log("不在小程序里");
        //进入弹窗来的
        this.showTipPopup();
      }
      report.Cooperatem_1004();
    },
    //使用规则弹窗
    showRulePopup() {
      this.rulePopShow = true;
      this.tipPopShow = false;
    },
    //隐藏使用规则弹窗
    hiddenRulePopup() {
      this.rulePopShow = false;
    },
    //webvie环境提醒弹窗
    showTipPopup() {
      this.GFH_POST('generateUrlscheme', { path: '/packageSub/pages/activity/H5GetCoupon/login', query: '' }).then(res => {
            location.href = res.data
      })
      // this.tipPopShow = true;
      // this.rulePopShow = false;
      // report.Cooperatem_1002();
    },
    //隐藏webvie环境提醒弹窗
    hiddenTipPopup() {
      this.tipPopShow = false;
    },
    checkoutEnv() {
      if (this.inWxAPP) {
        this.hiddenTipPopup();
        wx.miniProgram.navigateTo({
          url: "/pages/memberFiles/card/card"
        });
      } else {
        this.showTipPopup();
      }
    }
  }
};
</script>
<style scoped>
/* 提示弹框 */

.tipPop {
  background-color: rgba(0, 0, 0, 0.65);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.tipPop .popContent {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  max-height: 80%;
  background-color: white;
  border-radius: 16px 16px 0 0;
}
.tipPop .title {
  margin: 36px 20px 0 20px;
  font-family: SourceHanSansCN-Medium;
  font-size: 30px;
  color: #333333;
  font-weight: 800;
}
.tipPop .lineYellow {
  margin: 0 20px;
  width: 24px;
  height: 4px;
  background-color: #ffc900;
}
.tipPop .tip {
  margin: 24px 16px 0 16px;
  font-size: 14px;
  color: #999999;
  line-height: 28px;
}
.tipPop .btnArea {
  margin: 10px 16px 0 16px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.tipPop .btn {
  height: 50px;
  width: 100%;
  background-color: #f8cd2b;
  border-radius: 23.5px;
  font-weight: 800;
}
.volunteerBotton{
  width: 100%;
  height: 48px;
  position: absolute;
  bottom: 116px;
  text-align: center;
}
.volunteerBotton img {
  width: 343px;
  margin-bottom: 15px;
}
.volunteerBotton div{
  font-size: 12px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 14px;
}
/* 规则弹窗 */

.rulePop {
  background-color: rgba(0, 0, 0, 0.65);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  box-sizing: border-box;
  padding: 100px 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.rulePop .popContent {
  max-height: 100%;
  width: 100%;
  background: white;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 0 30px;
  border-radius: 2px;
}
.rulePop .title {
  text-align: center;
  line-height: 54px;
  font-size: 18px;
  color: #333333;
  font-weight: 800;
  text-align: center;
}
.rulePop .detail {
  overflow: scroll;
  flex-grow: 1;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #999999;
  line-height: 24px;
}
.rulePop .btnArea {
  margin-top: 10px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.rulePop .btnArea .btn {
  height: 50px;
  width: 100%;
  background-color: #f8cd2b;
  border-radius: 23.5px;
  font-weight: 800;
}

.content {
  flex-grow: 1;
  overflow: hidden;
  background-origin: content; /*从content区域开始显示背景*/
  background-position: 50% 50%; /*图片上下左右居中*/
  background-size: cover; /*保持图像本身的宽高比例，将图片缩放到宽度或高度正好适应定义背景的区域*/
  background-repeat: no-repeat; /*图像不重复显示*/
}
.getCoupon {
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
}
.titleTop {
  font-family: PingFangSC-Medium;
  font-size: 18px;
  color: #333333;
  letter-spacing: 0.29px;
  text-align: center;
  height: 50px;
  line-height: 50px;
  width: 100%;
  margin: 0 auto;
}
.bg {
  /* width: 100%; */
  height: 100%;
}
.bottom{
  position: absolute;
  bottom: 0;
  left: 0;right: 0;

  padding-bottom: 0px; /* iOS 10 */
padding-bottom: constant(safe-area-inset-bottom); /* iOS 11.0-iOS 11.1 */
padding-bottom: env(safe-area-inset-bottom); /*iOS 11.2 */
}
.inputPhoneArea {
  /* position: absolute;

  bottom: 100px; */

  padding: 0 16px;
  margin-bottom: 30px;
  width: 100%;
  box-sizing: border-box;
}
.inputPhone {
  background: #ffffff;
  border-radius: 4px;
  width: 100%;
  line-height: 46px;
  padding-left: 24px;
  box-sizing: border-box;
}
input::-webkit-input-placeholder {
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #cccccc;
}
.getCouponBottonArea {
  /* position: absolute;
  bottom: 40px; */
  margin-bottom: 20px;
  padding: 0 16px;
  width: 100%;
  box-sizing: border-box;
}
.getCouponBotton {
  width: 100%;
  height: 46px;
  border-radius: 2px;

}
.useRule {
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #cccccc;
  /* position: absolute; */
  width: 100%;
  text-align: center;
  line-height: 20px;
  /* left: 44%; */
  /* bottom: 12px; */
  
  text-decoration: underline;
}
.volunteerBanner{
  width: 100%;
  height: 100%;
  position: absolute;
}
</style>